import axios from "axios";
import mockPayload from "../mocks/malla-curricular-espanol.json";
import { MALLA_MATERIAS } from "../data/licenciaturaCourseDetail.materias";
import { normalizeLicenciaturaResponse } from "../utils/normalizeLicenciaturaResponse";

const USE_MALLA_MOCK = process.env.REACT_APP_USE_MALLA_MOCK === "true";

function buildMockLicenciatura(id) {
  const attributes = {
    ...mockPayload.data.attributes,
    MallaCurricular: {
      ...mockPayload.data.attributes.MallaCurricular,
      Materias: MALLA_MATERIAS,
    },
  };
  return normalizeLicenciaturaResponse({
    data: {
      id: Number(id) || mockPayload.data.id,
      attributes,
    },
  });
}

function shouldFallbackToMock(attributes) {
  const materias = attributes?.MallaCurricular?.Materias;
  return !materias || materias.length === 0;
}

/**
 * @returns {Promise<{ id: number|null, attributes: object|null }>}
 */
export async function fetchLicenciaturaById(id) {
  if (USE_MALLA_MOCK) {
    return buildMockLicenciatura(id);
  }

  const baseUrl = process.env.REACT_APP_API_URL;
  if (!baseUrl) {
    console.warn("[licenciaturaApi] REACT_APP_API_URL missing; using mock.");
    return buildMockLicenciatura(id);
  }

  const query =
    "populate[MallaCurricular][populate]=Materias&populate[ImagenLicenciatura]=*";
  const url = `${baseUrl}/api/licenciaturas/${id}?${query}`;

  try {
    const response = await axios.get(url);
    const normalized = normalizeLicenciaturaResponse(response.data);

    if (shouldFallbackToMock(normalized.attributes)) {
      console.warn(
        "[licenciaturaApi] Empty malla from API; falling back to mock materias."
      );
      const mock = buildMockLicenciatura(id);
      if (normalized.attributes) {
        mock.attributes = {
          ...normalized.attributes,
          MallaCurricular: mock.attributes.MallaCurricular,
        };
      }
      return mock;
    }

    return normalized;
  } catch (error) {
    console.warn("[licenciaturaApi] Request failed; using mock.", error.message);
    return buildMockLicenciatura(id);
  }
}
